import config from '../../config';
import { authFetch as fetch } from '../../common/authentication';

// A request with no answer by then counts as failed, so a page never waits for good (ANS-1118).
export const PREFERENCES_TIMEOUT_MS = 15000;

function withTimeout(promise) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(
      () => reject(new Error('preferences request timed out')),
      PREFERENCES_TIMEOUT_MS,
    );
    promise.then(resolve, reject).finally(() => clearTimeout(timer));
  });
}

export default function preferencesMiddleware(store) {
  // Only the newest load's answer counts: an earlier one landing late is older news.
  let newestLoad = 0;
  return (next) => (action) => {
    switch (action.type) {
      case 'preferences/get': {
        const load = ++newestLoad;
        store.dispatch({ type: 'preferences/loading' });
        withTimeout(getPreferences())
          .then((payload) => {
            if (load !== newestLoad) return;
            store.dispatch({ type: 'preferences/update', payload: payload });
          })
          .catch((error) => {
            console.log(error);
            if (load !== newestLoad) return;
            // A page waiting for the saved currency goes on with the default.
            store.dispatch({ type: 'preferences/loadFailed' });
          });
        break;
      }
      case 'preferences/save': {
        // The save reaches the store at once, so a save sent before this one is acknowledged
        // still carries it. It is acknowledged as a save, never as a load.
        store.dispatch({ type: 'preferences/saved', payload: action.payload });
        const { loaded, requests, ...prefs } = store.getState().preferences;
        withTimeout(savePreferences(prefs)).then(
          () => store.dispatch({ type: 'preferences/saveSettled' }),
          (error) => {
            console.log(error);
            store.dispatch({ type: 'preferences/saveSettled', payload: { failed: true } });
          },
        );
        break;
      }
        default:
            return next(action);
    }
  };
}

function getPreferences() {
    return new Promise((resolve,reject) => {
        fetch(config.endpoints.preferences, {
            headers: { 'Content-Type': 'application/json' },
        })
        .then((res) => {
            return res.json()
        })
        .then((result) => resolve(result))
        .catch(reject);
    });
}

function savePreferences(preferences) {
  return fetch(config.endpoints.preferences, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(preferences),
  });
}
